import { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  BasicDetail_INVESTOR_NEW,
  Currency,
  RegistrationIds,
} from "../../../assets/interface/primeSharkWebsite_interface";
import { useTranslation } from "react-i18next";
import { Label } from "../../Common/Label/Label";
import "react-intl-tel-input/dist/main.css";
import HelperService from "../../../Services/HelperService";
import IntlTelInput from "react-intl-tel-input";
import WebService from "../../../Services/WebService";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import CompoLoader from "../../ComponentLoader/CompoLoader";
import Select from "react-dropdown-select";
import BasicDetails_INDIVIDUAL_INVESTOR from "./BasicDetails_INDIVIDUAL_INVESTOR";
import BasicDetails_INSTITUTIONAL_INVESTOR from "./BasicDetails_INSTITUTIONAL_INVESTOR";
import { useDispatch, useSelector } from "react-redux";
import { storePrefferedCurrency } from "../../../config/action";
import CommonScrollbar from "../../Common/ScrollBar/CommonScrollbar";
import RequiredLabel from "../../Common/RequiredLabel/RequiredLabel";
import { validatePassword } from "../../Common/PasswordInput";
import { getProfileJourneyInfo } from "../../../Services/CommonFunction";

interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from: string;
  emptyImpKeys: any;
  fields_to_improve?: any;
}
interface SelectOption {
  label: string;
  value: string;
}
const entityList = [
  { label: "Individual Investor", value: "INDIVIDUAL_INVESTOR" },
  { label: "Institutional Investor", value: "INSTITUTION_INVESTOR" },
];
const BasicDetails_INVESTOR = ({
  handleNext,
  impIds,
  from,
  emptyImpKeys,
  fields_to_improve,
}: PropsData) => {
  const { t } = useTranslation();
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const selectedCurrency: Currency = useSelector(
    (state: any) => state?.items?.storedPrefferedCurrency,
  );
  const params = useParams();
  const login_type = params?.login_type;
  const [basicDetails, setBasicDetails] = useState<BasicDetail_INVESTOR_NEW>({
    type_of_entity: "INDIVIDUAL_INVESTOR",
    first_name: "",
    last_name: "",
    email: "",
    dial_code: "",
    country_code: "",
    mobile_number: "",
    login_type: "INVESTOR",
    address: "",
    password: "",
    city: "",
    state: "",
    account_type: "INVESTOR",
    postal_code: "",
    country: "",
    investment_experience: "",
    area_of_investment: [],
    designation_role: "",
    linkdin_profile: "",
    business_email: "",
    whatsapp_number: "",
    operational_region: [],
    preferred_currency: selectedCurrency ? selectedCurrency?.code : "",
    profile_photo: "",
    institution_investor_other: "",
    social_id: "",
    login_field: "",
    email_verified_at: null,
    mobile_verified_at: null,
  });
  const [isValid, setIsValid] = useState(true);
  const [emailVerifiedAt, setEmailVerifiedAt] = useState(false);
  const [mobileVerifiedAt, setMobileVerifiedat] = useState(false);
  const stored_password = sessionStorage.getItem("temp_password");
  const [apiCallTriggered, setAPICallTriggered] = useState(false);
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  let dispatch = useDispatch();
  useEffect(() => {
    if (impIds?.uuid) {
      getBasicDetails();
    }
  }, []);

  let locationVar = useLocation();
  const socialData = locationVar?.state?.social_data;

  useEffect(() => {
    if (socialData) {
      setBasicDetails((prev: BasicDetail_INVESTOR_NEW) => ({
        ...prev,
        // split name if needed
        first_name: socialData?.name?.split(" ")[0] || "",
        last_name: socialData?.name?.split(" ").slice(1).join(" ") || "",

        email: socialData?.email || "",

        // optional (if you store provider info)
        login_field: socialData?.provider,
        social_id: socialData?.provider_id,
      }));

      // optionally mark email verified
      // setEmailVerifiedAt(true);
    }
  }, [socialData]);

  const getBasicDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-detail/${impIds?.uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.info) {
          if (res?.status) {
            let info = res?.info;
            let businessInfo = res?.info?.business_info;
            let investor_business_details =
              businessInfo?.investor_business_details;
            setBasicDetails((prevBasicDetails: BasicDetail_INVESTOR_NEW) => ({
              ...prevBasicDetails,
              login_type: "INVESTOR",
              account_type: "INVESTOR",
              first_name: info?.first_name,
              last_name: info?.last_name,
              email: info?.email,
              business_email: investor_business_details?.business_email,
              firm_name: investor_business_details?.firm_name,
              website_url: investor_business_details?.website_url,
              dial_code: info?.dial_code,
              country_code: info?.country_code,
              mobile_number: info?.mobile_number ?? "",
              // login_type: investor_business_details?.login_type ?? login_type?.toLocaleUpperCase(),
              address: investor_business_details?.address,
              area_of_investment:
                investor_business_details?.area_of_investments,
              city: investor_business_details?.city,
              country: investor_business_details?.country,
              institution_investor_other:
                investor_business_details.institution_investor_other,
              postal_code: investor_business_details?.postal_code,
              state: investor_business_details?.state,
              type_of_entity:
                investor_business_details?.type_of_entity ??
                "INDIVIDUAL_INVESTOR",
              type_of_institution_investor:
                investor_business_details?.type_of_institution_investor,
              preferred_currency: info?.preferred_currency,
              linkdin_profile: investor_business_details?.linkdin_profile,
              whatsapp_number: investor_business_details?.whatsapp_number,
              investment_experience:
                investor_business_details?.investment_experience,
              designation_role: investor_business_details?.designation_role,
              operational_region: investor_business_details?.operational_region,
              password:
                from !== "REVIEW" && impIds?.business_uuid
                  ? stored_password || ""
                  : "",
              mobile_verified_at: info?.mobile_verified_at,
              email_verified_at: info?.email_verified_at,
            }));
            setEmailVerifiedAt(res?.info?.email_verified_at ? true : false);
            setMobileVerifiedat(res?.info?.mobile_verified_at ? true : false);
            if (info?.currency) {
              dispatch(storePrefferedCurrency(info?.currency));
            }
          } else {
            toast.error(res.message);
          }
        } else {
          emptyImpKeys();
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleChange = (name: string, value: any) => {
    let val = value;
    if (name === "whatsapp_number" && typeof value === "string") {
      val = value.replace(/[^0-9+-\s]/g, "");
    }
    setBasicDetails((prevBasicDetails: BasicDetail_INVESTOR_NEW) => ({
      ...prevBasicDetails,
      [name]: val,
    }));
  };
  const handleSaveBasicDetails = (flag: boolean) => {
    if (basicDetails?.type_of_entity === "INDIVIDUAL_INVESTOR") {
      if (
        HelperService?.checkFormEmptyFields(basicDetails, [
          "firm_name",
          "website_url",
          "designation_role",
          "type_of_institution_investor",
          "linkdin_profile",
          "profile_photo",
          "business_email",
          "city",
          "state",
          "postal_code",
          "linkdin_profile",
          "whatsapp_number",
          "mobile_number",
          "investment_experience",
          "institution_investor_other",
          "password",
          "login_field",
          "social_id",
          "mobile_verified_at",
          "email_verified_at",
        ])
      ) {
        setErrorFlag(true);
        return;
      } else if (
        !HelperService.isValidEmail(basicDetails?.email) ||
        (basicDetails?.business_email &&
          !HelperService.isValidEmail(basicDetails?.business_email))
      ) {
        setErrorFlag(true);
        return;
      } else if (
        (!basicDetails?.password ||
          !validatePassword(basicDetails?.password)) &&
        from !== "REVIEW" &&
        from !== "FROM_PROFILE_ANALYSIS"
      ) {
        setErrorFlag(true);
        return;
      } else {
        setErrorFlag(false);
      }
    }
    if (basicDetails?.type_of_entity === "INSTITUTION_INVESTOR") {
      if (
        HelperService?.checkFormEmptyFields(basicDetails, [
          "profile_photo",
          "investment_experience",
          "area_of_investment",
          "operational_region",
          "business_email",
          "address",
          "city",
          "state",
          "postal_code",
          "linkdin_profile",
          "whatsapp_number",
          "investment_experience",
          "designation_role",
          "institution_investor_other",
          "website_url",
          "password",
          "mobile_number",
          "login_field",
          "social_id",
          "mobile_verified_at",
          "email_verified_at",
        ]) || (basicDetails?.linkdin_profile &&
          !HelperService.checkLinkedinUrl(
            basicDetails?.linkdin_profile,
          )) ||
        (basicDetails.type_of_institution_investor === "Other" &&
          basicDetails.institution_investor_other === "")
      ) {
        setErrorFlag(true);
        return;
      } else if (!HelperService.isValidEmail(basicDetails?.email)) {
        setErrorFlag(true);
        return;
      } else {
        setErrorFlag(false);
      }
    }

    if (impIds?.business_uuid) {
      handleUpdateBasicDetailsApiCall(flag);
    } else {
      handleSaveBasicDetailsApiCall(flag);
    }
  };
  const FCMDeviceToken = useSelector(
    (state: any) => state?.items?.FCMDeviceToken,
  );

  const handleSaveBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = {
      ...basicDetails,
      mobile_number: HelperService.removeDialCode(
        basicDetails?.mobile_number,
        basicDetails?.dial_code,
      ),
    };
    if (basicDetails?.type_of_entity === "INDIVIDUAL_INVESTOR") {
      updatedata = {
        ...basicDetails,
        mobile_number: HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        ),
        type_of_institution_investor: "",
        firm_name: "",
        website_url: "",
      };
    } else {
      updatedata = {
        ...basicDetails,
        mobile_number: HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        ),
        investment_experience: "",
      };
    }
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    return WebService.postAPI({
      action: `basic-detail/${login_type}`,
      body: { ...updatedata, device_token: FCMDeviceToken },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          if (!res?.email_verification_require) toast.success(res.message);
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };
  const handleUpdateBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = { ...basicDetails };
    if (basicDetails?.type_of_entity === "INDIVIDUAL_INVESTOR") {
      updatedata = {
        ...basicDetails,
        mobile_number: basicDetails?.mobile_number
          ? HelperService.removeDialCode(
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
          )
          : "",
        type_of_institution_investor: "",
        firm_name: "",
        website_url: "",
      };
    } else {
      updatedata = {
        ...basicDetails,
        mobile_number: basicDetails?.mobile_number
          ? HelperService.removeDialCode(
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
          )
          : "",
        investment_experience: "",
      };
    }
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `basic-detail/investor/${impIds?.uuid}/${impIds?.business_uuid}`,
      body: updatedata,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          if (!res?.email_verification_require) toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.login_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };

  const handleArrayValueChange = (value: any, key: string) => {
    console.log(value, "test", key);

    let change = false;

    if (
      key === "type_of_institution_investor" &&
      !Array.isArray(value) &&
      value.value !== "Other"
    ) {
      change = true;
    }

    setBasicDetails((prevDetails: BasicDetail_INVESTOR_NEW) => ({
      ...prevDetails,
      [key]: Array.isArray(value)
        ? value.map((item: any) => ({ title: item.value, other: item?.other })) // ✅ typed
        : value?.value,
      institution_investor_other: change
        ? ""
        : prevDetails.institution_investor_other,
    }));
  };

  const handlePhoneChange = useCallback((value: any, countryData: any) => {
    if (
      value !== basicDetails?.mobile_number ||
      countryData?.dialCode != basicDetails?.dial_code
    ) {
      setBasicDetails((prev: BasicDetail_INVESTOR_NEW) => ({
        ...prev,
        dial_code: countryData?.dialCode,
        mobile_number: value,
        country_code: countryData?.iso2,
      }));
    }
  }, []);

  return (<>
    <CommonScrollbar height={"75vh"}>
      <div className="login-form w-100  position-relative me-2">
        {loader ? <CompoLoader /> : null}
        <div className="custom-title my-auto font-bold mb-2">
          {t("Register.Basic_Details")}
        </div>
        <p className="font-14 mb-1">{t("Register.basic_details_msg")}</p>
        <Col lg={12} className="mb-2">
          <RequiredLabel isRequired={true}>Type Of Entity</RequiredLabel>

          <Select
            dropdownHeight="200px"
            options={entityList}
            onChange={(values: any) => {
              if (values?.length > 0) {
                setBasicDetails(
                  (prevBasicDetails: BasicDetail_INVESTOR_NEW) => ({
                    ...prevBasicDetails,
                    type_of_entity: values[0]?.value,
                  }),
                );
              }
            }}
            labelField="label"
            valueField="value"
            name="choose_profile"
            values={
              basicDetails?.type_of_entity
                ? [
                  {
                    value: basicDetails?.type_of_entity,
                    label: HelperService.removeUnderScore(
                      basicDetails?.type_of_entity,
                    ),
                  },
                ]
                : []
            }
          />
        </Col>
        {basicDetails?.type_of_entity === "INDIVIDUAL_INVESTOR" && (
          <BasicDetails_INDIVIDUAL_INVESTOR
            basicDetails={basicDetails}
            errorFlag={errorFlag}
            handleChange={handleChange}
            handlePhoneNumberChange={handlePhoneChange}
            handleArrayValueChange={(value: any[], key: string) =>
              handleArrayValueChange(value, key)
            }
            fields_to_improve={fields_to_improve}
            emailVerifyAt={emailVerifiedAt}
            from={from}
            skipButtonClicked={skipButtonClicked}
          />
        )}

        {basicDetails?.type_of_entity === "INSTITUTION_INVESTOR" && (
          <BasicDetails_INSTITUTIONAL_INVESTOR
            basicDetails={basicDetails}
            errorFlag={errorFlag}
            handleChange={handleChange}
            handlePhoneNumberChange={handlePhoneChange}
            isValid={isValid}
            handleArrayValueChange={(value: any[], key: string) =>
              handleArrayValueChange(value, key)
            }
            fields_to_improve={fields_to_improve}
            emailVerifyAt={emailVerifiedAt}
            from={from}
            skipButtonClicked={skipButtonClicked}
          />
        )}
        {/* <div className="mb-2">
          <Button
            className="btn btn-primary w-100"
            type="button"
            id="save_basic_details"
            onClick={handleSaveBasicDetails}
            disabled={apiCallTriggered}
          >
            {" "}
            {from && from === "REVIEW"
              ? t("Register.save")
              : t("Register.continue")}
          </Button>
        </div> */}
        <div className="mb-2 d-flex gap-2">
          <Button
            className={
              from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                ? "btn btn-primary w-100"
                : "btn btn-primary w-50"
            }
            disabled={apiCallTriggered}
            type="button"
            id="save_basic_details"
            onClick={() => {
              setSkipButtonClicked(false);
              handleSaveBasicDetails(false);
            }}
          >
            {" "}
            {from && from === "REVIEW"
              ? t("Register.save")
              : t("Register.continue")}
          </Button>
          {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
            <Button
              className="btn btn-secondary w-50"
              type="button"
              id="skip_basic_details"
              onClick={() => {
                setSkipButtonClicked(true);
                handleSaveBasicDetails(true);
              }}
              disabled={apiCallTriggered}
            >
              Skip
            </Button>
          )}
        </div>
      </div>
    </CommonScrollbar>
  </>
  );
};

export default BasicDetails_INVESTOR;
